const _ = {
  actions: {
    GetCertList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/cert/list',
          method: 'get',
          params: {
            a_langset_id: mm.store.state.currentLanguage,
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
  }
}

export default _
